import Velocity from 'velocity-animate'

// Above this many children the staggered enter animation hides content for
// seconds (delay = index * timeIn), so large lists render immediately.
const ANIMATED_ITEM_LIMIT = 15
// Cap the stagger so later items in small lists do not wait excessively.
const MAX_STAGGER_STEPS = 8

export default {
	functional: true,
	render (createElement, context) {
		const children = context.children || []
		const tag = (context.props.tag) ? context.props.tag : 'ul'
		const className = (context.data.staticClass || context.data.class) ? context.data.staticClass || context.data.class : null

		if (children.length > ANIMATED_ITEM_LIMIT) {
			return createElement(tag, { class: className }, children)
		}

		return createElement('TransitionGroup', {
			class: className,
			props: {
				name: 'list-transition',
				css: false,
				tag
			},
			on: {
				beforeEnter (el) {
					el.style.opacity = 0
				},
				enter (el, done) {
					const timeIn = context.props.timeIn !== undefined ? context.props.timeIn : 30
					const delay = Math.min(el.dataset.index || 0, MAX_STAGGER_STEPS) * timeIn
					Velocity(el, {
						opacity: 1
					}, {
						delay,
						complete: done,
						duration: 200,
						easing: ['.8', '-0.6', '0.2', '1.5']
					})
				},
				leave (el, done) {
					el.style.opacity = 0
					done()
				}
			}
		}, children)
	}
}
